/**
 * Move to the product selector file
 */
 
let ScrollMagic = require('scrollmagic');
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap').default;
require('scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators');
 
import $ from 'jquery';

// Module options
const vars = {
	isOpen: false,
	scene: null,
	controller: null
};

const selectors = { 
	stickyMessage: '.js-sticky-message',
	unStickAtThisElement: '.c-footer'
};

// Cached elements
const $el = {
	stickyMessage: $(selectors.stickyMessage),
	toggle: $('.js-sticky-message-toggle'),
	stickyMessageContent: $('.js-sticky-message-content'),
};

// Module events
export default function init() {
	
	if (!$el.stickyMessage.length) return;
	
	sticky();
	bindEvents();
}

// User interactions go here
function bindEvents() {
	$el.toggle.on('click', (e) => {
		e.preventDefault();
		
		if (vars.isOpen) {
			closeStickyMessage();
			vars.isOpen = false;
		} else {
			openStickyMessage();
			vars.isOpen = true;
		}

	});
}

export function showStickyMessage() {
	$el.stickyMessage.addClass('is-showing');
}

export function hideStickyMessage() {
	$el.stickyMessage.removeClass('is-showing');
}

function openStickyMessage() {
	$el.stickyMessage.addClass('is-open');
	$el.stickyMessageContent.slideDown();
}

function closeStickyMessage() {
	$el.stickyMessage.removeClass('is-open');
	$el.stickyMessageContent.slideUp();
}

function sticky() {
	// Initialise the ScrollMagic controller
	vars.controller = new ScrollMagic.Controller();
	
	// When the sticky message reaches the footer, unstick it
	vars.scene = new ScrollMagic.Scene({
		triggerHook: 'onEnter',
		triggerElement: selectors.unStickAtThisElement
	})
	// .addIndicators({ name: 'stickyMessage' })
	.setClassToggle(selectors.stickyMessage, 'is-unfixed')
	.addTo(vars.controller);
}
